"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Modal = require("@insided/shared/uikit/Modal");

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var IpModal = function IpModal(_ref) {
  var onClose = _ref.onClose,
      authorName = _ref.authorName,
      ipData = _ref.ipData;
  var post = ipData.post,
      user = ipData.user,
      hostname = ipData.hostname,
      usersPosted = ipData.usersPosted,
      usersRegged = ipData.usersRegged;
  return (0, _preact.h)(_preactPortal.default, {
    into: "body"
  }, (0, _preact.h)(_Modal.Modal, {
    isOpen: true,
    size: "medium",
    className: "view-ip-details-modal"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Ip information for ".concat(authorName),
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
    className: "ip-details-container"
  }, (0, _preact.h)("div", {
    className: "ip-details-section"
  }, (0, _preact.h)("div", {
    className: "ip-detail-item"
  }, (0, _preact.h)("span", {
    className: "ip-detail-label"
  }, "IP address:"), (0, _preact.h)("span", {
    className: "ip-detail-value"
  }, post.ipaddress)), (0, _preact.h)("div", {
    className: "ip-detail-item"
  }, (0, _preact.h)("span", {
    className: "ip-detail-label"
  }, "Hostname:"), (0, _preact.h)("span", {
    className: "ip-detail-value"
  }, hostname)), (0, _preact.h)("div", {
    className: "ip-detail-item"
  }, (0, _preact.h)("span", {
    className: "ip-detail-label"
  }, "Registration IP address:"), (0, _preact.h)("span", {
    className: "ip-detail-value"
  }, user.ipaddress))), (0, _preact.h)("div", {
    className: "ip-users-section"
  }, (0, _preact.h)("div", {
    className: "ip-users-group"
  }, (0, _preact.h)("h4", {
    className: "ip-users-title"
  }, "Users who posted from the same IP address:"), (0, _preact.h)("div", {
    className: "ip-users-list"
  }, usersPosted.length === 0 ? (0, _preact.h)("span", {
    className: "ip-users-empty"
  }, "None") : usersPosted.map(function (_ref2, index) {
    var posts = _ref2.posts,
        userUrl = _ref2.userUrl,
        username = _ref2.username;
    return (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)(userUrl),
      key: index,
      className: "ip-user-link"
    }, (0, _preact.h)("span", {
      className: "ip-username"
    }, username), (0, _preact.h)("span", {
      className: "ip-post-count"
    }, "(", posts, " Posts)"));
  }))), (0, _preact.h)("div", {
    className: "ip-users-group"
  }, (0, _preact.h)("h4", {
    className: "ip-users-title"
  }, "Users who registered from the same IP address:"), (0, _preact.h)("div", {
    className: "ip-users-list"
  }, usersRegged.length === 0 ? (0, _preact.h)("span", {
    className: "ip-users-empty"
  }, "None") : usersRegged.map(function (_ref3, index) {
    var posts = _ref3.posts,
        userUrl = _ref3.userUrl,
        username = _ref3.username;
    return (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)(userUrl),
      key: index,
      className: "ip-user-link"
    }, (0, _preact.h)("span", {
      className: "ip-username"
    }, username), (0, _preact.h)("span", {
      className: "ip-post-count"
    }, "(", posts, " Posts)"));
  }))))))));
};

var _default = IpModal;
exports.default = _default;